// import React from "react";

// const TextField = (props) => {
//   return (
//     <div className="form-control-textfieldd">
//       <label htmlFor={props.field}>{props.displayName}</label>
//       <input
//         {...props}

//         className="form-control-textfieldd"
//       />
//       <div className="text-danger-textfieldd">
//         {props.error}
//       </div>
//     </div>
//   );
// };

// TextField.defaultProps = {
//   type: "text",
// };
// export default TextField;

import React from "react";

const TextField = (props) => {
  return (
    <div className="form-control-textfieldd">
      <label htmlFor={props.name}>{props.displayName}</label>
      <input
        {...props}
        className={props.className ? props.className : "form-control-textfieldd"}
      />
      {props.error && <div className="text-danger-textfieldd">{props.error}</div>}
    </div>
  );
};

TextField.defaultProps = {
  type: "text",
  displayName: "", // default name for label if none is provided
};

export default TextField;

